import {
  ButtonProps,
  IconDropDownProps,
  IconProps,
  TextProps,
} from 'spindl-shared-components';


type FieldColumnItemInternalProps = {
  icon?: IconProps;
  text?: TextProps;
  indicator?: TextProps;
  sortButton?: ButtonProps;
  filterDropdown?: IconDropDownProps;
};

type FieldColumnItemPropsValues = {
  'DefaultCellLarge': FieldColumnItemInternalProps;
  'DefaultCellMedium': FieldColumnItemInternalProps;
  'DefaultCellSmall': FieldColumnItemInternalProps;
  'DefaultModalDefault': FieldColumnItemInternalProps;
  'RequiredCellLarge': FieldColumnItemInternalProps;
  'RequiredCellMedium': FieldColumnItemInternalProps;
  'RequiredCellSmall': FieldColumnItemInternalProps;
  'RequiredModalDefault': FieldColumnItemInternalProps;
};

const propValues: FieldColumnItemPropsValues = {
  'DefaultCellLarge': {
    icon: {
      asset: 'Text',
      colour: 'IconDark',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
    sortButton: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    filterDropdown: {},
  },
  'DefaultCellMedium': {
    icon: {
      asset: 'Text',
      colour: 'IconDark',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
    sortButton: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    filterDropdown: {},
  },
  'DefaultCellSmall': {
    icon: {
      asset: 'Text',
      colour: 'IconDark',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
    sortButton: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    filterDropdown: {},
  },
  'DefaultModalDefault': {
    icon: {
      asset: 'Text',
      colour: 'IconDark',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
    sortButton: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    filterDropdown: {},
  },
  'RequiredCellLarge': {
    icon: {
      asset: 'Text',
      colour: 'IconDark',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
    indicator: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Destructive',
      type: 'Heading5',
    },
    sortButton: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    filterDropdown: {},
  },
  'RequiredCellMedium': {
    icon: {
      asset: 'Text',
      colour: 'IconDark',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
    indicator: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Destructive',
      type: 'Heading5',
    },
    sortButton: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    filterDropdown: {},
  },
  'RequiredCellSmall': {
    icon: {
      asset: 'Text',
      colour: 'IconDark',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
    indicator: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Destructive',
      type: 'Heading5',
    },
    sortButton: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    filterDropdown: {},
  },
  'RequiredModalDefault': {
    icon: {
      asset: 'Text',
      colour: 'IconDark',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
    indicator: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Destructive',
      type: 'Heading5',
    },
    sortButton: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    filterDropdown: {},
  },
};

const getProps = (type: string): FieldColumnItemInternalProps => {
  const values: FieldColumnItemInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
